import React from 'react';

export const Map = () => {
  return (
    <iframe
      className="map"
      style={{
        border: 0,
        width: '100%',
        minHeight: '564px',
        borderRadius: '10px',
      }}
      referrerPolicy="no-referrer-when-downgrade"
      src="https://www.google.com/maps/embed/v1/place?key=AIzaSyB9RL2OWh7egN6rVcs3AtxCotYCaE7bFUE&q=16950+Via+De+Santa+Fe+5060+136,+Rancho+Santa+Fe,+CA+92091,+USA&zoom=18&language=en"
      allowFullScreen
    ></iframe>
  );
};
